import script from "./AppFeedbackModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppFeedbackModal.vue?vue&type=script&setup=true&lang=ts"

import "./AppFeedbackModal.vue?vue&type=style&index=0&id=d9503c58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9503c58"]])

export default __exports__